function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "14",
  height: "14",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M3.65 6.003c.206 0 .372.168.372.375a.374.374 0 01-.372.375H1.044v5.997h11.912V6.753H10.35a.374.374 0 01-.372-.375c0-.207.166-.375.372-.375h2.606c.41 0 .744.336.744.75v5.997c0 .414-.333.75-.744.75H1.044a.747.747 0 01-.744-.75V6.753c0-.414.333-.75.744-.75H3.65zM7.484.68l2.081 1.796a.377.377 0 01.04.529.37.37 0 01-.524.04L7.484 1.669a.747.747 0 00-.11-.08l-.002 8.539A.374.374 0 017 10.5a.374.374 0 01-.372-.374v-8.54a.747.747 0 00-.113.08L4.92 3.047a.37.37 0 01-.525-.041.377.377 0 01.04-.529L6.516.68a.74.74 0 01.97 0z",
  fill: "#54585D",
  fillRule: "nonzero",
  stroke: "#54585D",
  strokeWidth: ".5"
})));